import React, { memo } from 'react'
import InfoIcon from 'transfix-icons/build/InfoIcon'
import { useBreakpointContext } from 'utils/context/BreakpointContext'
import { getOverridePositionProp } from 'apps/fleet-planner/utils/getMobileTooltipPosition'
import { Tooltip } from 'transfix-ui'

interface IExternalTooltipMessageProps {
  tooltipMessage: string
  message: string
  id: string
}

export const ExternalTooltipMessage = memo<IExternalTooltipMessageProps>(
  ({ id, message, tooltipMessage }) => {
    const { isMobile = false } = useBreakpointContext()
    const overridePosition = getOverridePositionProp(isMobile)
    return (
      <div className='flex items-center'>
        <span className='text-secondary text-caption-semibold pr1'>{message}</span>
        <Tooltip
          id={id}
          position='top'
          type='dark'
          overridePosition={overridePosition}
          trigger={
            <span className='pt1'>
              <InfoIcon color='coolGray5' />
            </span>
          }>
          {tooltipMessage}
        </Tooltip>
      </div>
    )
  }
)
